
webpack.register(
    'modules/vc-profile/vc-profile',
    function() {
        return import('modules/vc-profile/vc-profile');
    },
    true
);